import React from "react";
import { Button, Loader, Panel, Pagination } from "@culturehq/components";
import { Template } from "chq";

import { Trans } from "app/utils";
import ErrorMessage from "components/common/ErrorMessage";
import PageHeader from "components/display/PageHeader";
import PromptIcon from "components/stories/PromptIcon";

import { TemplateBuilderProvider, useTemplateBuilder } from "./context/TemplateBuilderContext";
import styles from "./buildertemplates.module.scss";
import LibraryTemplate from "./LibraryTemplate";
import CreateTemplateButton from "./CreateTemplateButton";
import BuilderTemplateList from "./BuilderTemplateList";


const HeaderTitle = () => (
  <>
    <div className={styles["builder-template__title-text"]}>
      <div className={styles["builder-template__icon-text"]}>
        <PromptIcon />
      </div>
    </div>
    <div className={styles["builder-template__title-text"]}>
      <Trans>
        <h4>Branded Template</h4>
        Below is the list of your branded templates that can be leveraged
        inside the editing studio.
      </Trans>
    </div>
  </>
);

const HeaderActionButtons = () => {
  const { handleCreate } = useTemplateBuilder();

  return (
    <div className={styles["builder-template__container-buttons"]}>
      <div className={styles["builder-template__container-buttons__create-template"]}>
        <CreateTemplateButton />
      </div>
      <LibraryTemplate
        onSelectedTemplate={
          (template: Template) => handleCreate({ ...template, value: undefined })
        }
      >
        {(onTrigger: any) => (
          <p>
            <Button
              className={styles["builder-template__buttons__template-library"]}
              icon="plus"
              primary
              inverted
              onClick={onTrigger}
            >
              <Trans>Template Library</Trans>
            </Button>
          </p>
        )}
      </LibraryTemplate>
    </div>
  );
};

const BuilderTemplates = () => {
  const { state: { loading, error }, pagination, onPageClick } = useTemplateBuilder();

  return (
    <>
      <Panel limitWidth>
        <PageHeader title="">
          <HeaderTitle />
        </PageHeader>
        <HeaderActionButtons />
        <Panel.Body className="ManageUsers">
          <Loader loading={loading}>
            <BuilderTemplateList />
            <Pagination {...pagination} onClick={onPageClick} />
            {error && <ErrorMessage error={error} />}
          </Loader>
        </Panel.Body>
      </Panel>
    </>
  );
};

export default () => (
  <TemplateBuilderProvider>
    <BuilderTemplates />
  </TemplateBuilderProvider>
);
